import { Typography } from "@mui/joy";
import { Box } from "@mui/system";

import EmailsDataGrid from "features/dataGrids/EmailsDataGrid";
import { heightWithToolbar } from "global";
import { Helmet } from "react-helmet";
import { Outlet, useParams } from "react-router-dom";

export default function EmailsPage() {
  const param = useParams();
  if (param.emailID) return <Outlet />;

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          gap: 2,
          flexDirection: "column",
          justifyContent: "stretch",
          margin: "auto",
          maxWidth: 1600,
          width: "100%",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | Emails</title>
        </Helmet>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography level="h5">Emails</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            height: 0,
            minHeight: "auto",
          }}
        >
          <EmailsDataGrid autoHeight={false} />
        </Box>
      </Box>
    </>
  );
}
